import { createFileRoute } from '@tanstack/react-router';

import { Button, ButtonGroup } from '@/common/components/button';
import { Field, FieldGroup, FieldRow, Fieldset, Label, Legend } from '@/common/components/fieldset';
import { Heading } from '@/common/components/heading';
import { Input } from '@/common/components/input';
import { Select } from '@/common/components/select';
import { Text, TextLink } from '@/common/components/text';

export const Route = createFileRoute(
  '/applications/$application-id/service-location/new'
)({
  component: NewServiceLocationComponent
});

function NewServiceLocationComponent() {
  return (
    <div className="p-8">
      <Heading>New Metered Service</Heading>

      <div className="grid lg:grid-cols-2">
        <div className="flex flex-col justify-start">
          <Fieldset className="mt-4">
            <FieldGroup>
              <Field>
                <Label>Parcel ID</Label>
                <Input name="parcelId" />
              </Field>

              <Field>
                <Label>Requested Connect Date</Label>
                <Input type="date" name="requestedConnectDate" />
                <Text>Connections may not be available on weekends or holidays. If your requested connect date is unavailable, we will select the next business day.</Text>
              </Field>

              <Field>
                <Label>Service Description</Label>
                <Input name="serviceDescription" />
                <Text>Please provide a description of the service you are requesting, such as “home”, “shed”, or “workshop”.</Text>
              </Field>
            </FieldGroup>
          </Fieldset>
        </div>

        <div className="flex flex-col justify-start m-6">
          <p>Your parcel ID can be found on your:</p>

          <ul className="my-4 pl-10 list-disc">
            <li>Property deed and/or title,</li>
            <li>Property purchase contract, or</li>
            <li>County tax bill</li>
          </ul>

          <p>If you do not have access to any of those items, you can also search by Owner name or property address on the County Property Appraiser’s website where the property is located:</p>

          <ul className="my-4 pl-10 list-disc">
            <li><TextLink target="_blank" href="https://qpublic.schneidercorp.com/Application.aspx?App=GadsdenCountyFL&amp;PageType=Search">Gadsden County Property Appraiser</TextLink></li>
            <li><TextLink target="_blank" href="https://search.leonpa.gov/Terms?requestedAction=Property">Leon County Property Appraiser</TextLink></li>
            <li><TextLink target="_blank" href="https://qpublic.schneidercorp.com/Application.aspx?App=LibertyCountyFL&amp;Layer=Parcels&amp;PageType=Search">Liberty County Property Appraiser</TextLink></li>
            <li><TextLink target="_blank" href="https://beacon.schneidercorp.com/Application.aspx?AppID=836&amp;LayerID=15205&amp;PageTypeID=2&amp;PageID=6831">Wakulla County Property Appraiser</TextLink></li>
          </ul>
        </div>
      </div>

      <Fieldset className="mt-4">
        <Legend>Service Address</Legend>

        <FieldGroup>
          <FieldRow cols={2}>
            <Field>
              <Label>Address Line 1</Label>
              <Input name="line1" placeholder="1607 W Jefferson St." />
              <Text>Include at least the street name if the full address is not known yet.</Text>
            </Field>

            <Field>
              <Label>Address Line 2 (Optional)</Label>
              <Input name="line2" />
            </Field>
          </FieldRow>
          <FieldRow cols={6}>
            <Field className="lg:col-span-3">
              <Label>City</Label>
              <Input name="city" placeholder="Quincy" />
            </Field>

            <Field className="lg:col-span-2">
              <Label>State</Label>
              <Select name="state">
                <option value="FL">Florida</option>
              </Select>
            </Field>

            <Field>
              <Label>ZIP Code</Label>
              <Input name="zipCode" placeholder="32353" />
            </Field>
          </FieldRow>
        </FieldGroup>
      </Fieldset>

      <ButtonGroup>
        <Button to="/applications/$application-id/service-location" params={{ 'application-id': '1' }} outline>Back</Button>
        <Button to="/applications/$application-id/service-location/confirm" params={{ 'application-id': '1' }}>Next</Button>
      </ButtonGroup>
    </div>
  );
}
